// @flow strict
import type {
  Templates,
  SchedulerTemplatesState,
} from 'src/types/scheduler/templates.js';
import type {SchedulerTemplatesActions} from 'src/action-creators/scheduler/templates';

import uniqBy from 'lodash/uniqBy';

import {
  SET_INDIVIDUAL_TEMPLATES,
  SET_INDIVIDUAL_TEMPLATES_QUERY_PARAMS,
  ADD_NEW_INDIVIDUAL_TEMPLATE,
  APPEND_INDIVIDUAL_TEMPLATES,
  SET_TEAM_TEMPLATES,
  SET_TEAM_TEMPLATES_QUERY_PARAMS,
  ADD_NEW_TEAM_TEMPLATE,
  APPEND_TEAM_TEMPLATES,
  COPY_TEMPLATE,
  REMOVE_TEMPLATE,
} from 'src/action-creators/scheduler/templates.js';


const initialIndividualTemplatesQueryParams = {
  offset: '0',
  limit: '10',
  filters: {
    name: '',
  },
};

const initialTeamTemplatesQueryParams = {
  offset: '0',
  limit: '10',
  filters: {
    name: '',
    bookingAccount: [],
    distributionRule: [],
  },
};

const initialTemplatesState = {
  individualTemplates: {
    data: [],
    totalCount: 0,
    queryParams: initialIndividualTemplatesQueryParams,
  },
  teamTemplates: {
    data: [],
    totalCount: 0,
    queryParams: initialTeamTemplatesQueryParams,
  },
};

export default (
  state: SchedulerTemplatesState = initialTemplatesState,
  action: SchedulerTemplatesActions,
): SchedulerTemplatesState => {
  switch (action.type) {
    case SET_INDIVIDUAL_TEMPLATES:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: action.payload.data,
          totalCount: action.payload.totalCount,
        },
      };
    case APPEND_INDIVIDUAL_TEMPLATES:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: uniqueTemplates([
            ...state.individualTemplates.data,
            ...action.payload.data,
          ]),
          totalCount: action.payload.totalCount,
        },
      };
    case SET_INDIVIDUAL_TEMPLATES_QUERY_PARAMS:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          queryParams: action.payload,
        },
      };
    case ADD_NEW_INDIVIDUAL_TEMPLATE:
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          // TODO(Aditya): check where to add the new template in the list add unique template only
          data: uniqueTemplates([
            ...state.individualTemplates.data,
            action.payload,
          ]),
        },
      };

    case SET_TEAM_TEMPLATES:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: action.payload.data,
          totalCount: action.payload.totalCount,
        },
      };
    case APPEND_TEAM_TEMPLATES:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: uniqueTemplates([
            ...state.teamTemplates.data,
            ...action.payload.data,
          ]),
          totalCount: action.payload.totalCount,
        },
      };
    case SET_TEAM_TEMPLATES_QUERY_PARAMS:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          queryParams: action.payload,
        },
      };
    case ADD_NEW_TEAM_TEMPLATE:
      return {
        ...state,
        teamTemplates: {
          ...state.teamTemplates,
          data: uniqueTemplates([...state.teamTemplates.data, action.payload]),
        },
      };
    case REMOVE_TEMPLATE:
      const {templateId, isTeamTemplate: isTeamTemplateRemove} = action.payload;
      if (isTeamTemplateRemove) {
        return {
          ...state,
          teamTemplates: {
            ...state.teamTemplates,
            data: state.teamTemplates.data.filter(
              (template) => template.id !== templateId,
            ),
          },
        };
      }
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: state.individualTemplates.data.filter(
            (template) => template.id !== templateId,
          ),
        },
      };
    case COPY_TEMPLATE:
      const {template, isTeamTemplate: isTeamTemplateCopy} = action.payload;
      if (isTeamTemplateCopy) {
        return {
          ...state,
          teamTemplates: {
            ...state.teamTemplates,
            data: [...state.teamTemplates.data, template],
          },
        };
      }
      return {
        ...state,
        individualTemplates: {
          ...state.individualTemplates,
          data: [...state.individualTemplates.data, template],
        },
      };
    default:
      return state;
  }
};

// utils functions
const uniqueTemplates = (templates: Templates): Templates => {
  return uniqBy(templates, 'id');
};
